const PRIMARY_KEY = 'session_id';
const LEGACY_KEY = 'pdf_session_id';

export const getSessionId = () => {
  const existing = localStorage.getItem(PRIMARY_KEY) || localStorage.getItem(LEGACY_KEY);
  const sessionId = existing || `session_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;

  // Keep both keys during migration so existing anonymous file histories remain accessible.
  localStorage.setItem(PRIMARY_KEY, sessionId);
  localStorage.setItem(LEGACY_KEY, sessionId);
  return sessionId;
};
